import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(() => ({
  zoomScrollPaper: {
    "@media (max-height: 400px)": {
      display: "block",
      overflow: "auto"
    }
  },
  zoomScrollContent: {
    height: "auto",
    flex: 1,
    minHeight: 0,
    "@media (max-height: 400px)": {
      overflow: "visible",
      minHeight: "auto"
    }
  },
  footer: {
    borderTop: `1px solid ${blueGrey[100]}`
  }
}))
